import LayoutProviderSrc from './LayoutProvider';
import PageSrc from './Page';
import SectionSrc from './Section';
import SlotSrc from './Slot';

export const LayoutProvider = LayoutProviderSrc;
export const Page = PageSrc;
export const Section = SectionSrc;
export const Slot = SlotSrc;

export default {
  LayoutProvider,
  Page,
  Section,
  Slot,
};
